<template>
  <v-row class="ma-0" justify="center">
    <v-dialog v-model="showDialog" @click:outside="closeDialog" @keydown="value => (value.key === 'Escape' ? closeDialog() : '')" scrollable max-width="700px">
      <template v-slot:activator="{ on }">
        <v-icon small class="mr-2" @click=";(showDialog = true), getReceipt()" v-on="on">mdi-square-edit-outline</v-icon>
      </template>

      <v-card class="pa-1">
        <!-- card title -->
        <v-card-title>
          <v-row align="center" justify="space-between">
            <!-- creation date -->
            <v-col>
              <span style="font-size: 14px">{{ formattedInstantDate }}</span>
            </v-col>

            <!-- title -->
            <v-col class="text-center">
              <h3 class="main--text">{{ translations.receipt }}</h3>
            </v-col>

            <!-- processed status -->
            <v-col class="text-right">
              <v-chip small label :color="receipt.processed ? '#E7F5E9' : '#FFEAEC'" :style="{ color: receipt.processed ? '#2A6A2D' : '#D60011' }">
                {{ receipt.processed ? translations.processedReceipt : translations.notProcessed }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="mt-4">
            <v-col>
              <!-- description -->
              <p>{{ receipt.description }}</p>
            </v-col>
          </v-row>

          <!-- image -->
          <v-row no-gutters justify="center">
            <v-col style="max-width: 400px">
              <v-img class="pa-0 mt-4" :src="receipt.file && receipt.file.base64 ? `data:${receipt.file.fileType};base64,${receipt.file.base64}` : ''" width="100%"> </v-img>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-4">
            <v-col>
              <!-- employee list -->
              <p><b>{{ translations.employeeList }}:</b> {{ receipt.employeeList }}</p>

              <!-- company card -->
              <p><b>{{ translations.companyCard }}:</b> {{ receipt.companyCard ? translations.yes : translations.no }}</p>

              <!-- payedBy -->
              <p v-if="!receipt.companyCard"><b>{{ translations.payedBy }}:</b> {{ receipt.payedBy }}</p>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- actions -->
        <v-card-actions class="pb-4 pt-4">
          <v-row class="ma-0" :justify="!receipt.processed ? 'space-around' : 'center'">
            <v-btn @click="closeDialog" class="px-8" outlined :loading="loading">{{ translations.close }}</v-btn>

            <v-btn v-if="!receipt.processed" @click="processReceipt" color="main" class="white--text px-8" :loading="loading">{{ translations.approve }}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ReceiptsService from '@/service/receipts/ReceiptsService'
import { translations } from '@/utils/common'
import { MomentMixin } from '@/utils/mixins/MomentMixin.js'

export default {
  name: 'Receipt',

  props: {
    itemId: {
      required: true
    }
  },

  data() {
    return {
      translations: translations,

      showDialog: false,
      loading: false,
      receipt: {}
    }
  },

  mixins: [MomentMixin],

  methods: {
    closeDialog() {
      this.showDialog = false
    },

    async processReceipt() {
      try {
        this.loading = true
        await ReceiptsService.process({ receiptId: this.itemId, processed: true })
        this.$emit('updated')
        this.closeDialog()
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },

    async getReceipt() {
      try {
        this.loading = true
        this.receipt = await ReceiptsService.getById({ receiptId: this.itemId })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  },

  computed: {
    formattedInstantDate() {
      return this.momentDate(this.receipt.createdAt, 'DD/MM/YYYY HH:mm')
    }
  }
}
</script>
